
{
  "nav": {
    "about": "About",
    "expertise": "Expertise",
    "certifications": "Certifications",
    "connect": "Connect"
  },
  "hero": {
    "badge": "Finnish RN • Singapore Ready",
    "title": "Bridging Nordic Excellence with Southeast Asian Care",
    "stats": {
      "certifications": "Certifications",
      "languages": "Languages",
      "geriatric": "Geriatric Focus"
    },
    "cta": {
      "download": "Download CV",
      "whatsapp": "WhatsApp me",
      "explore": "Explore my two worlds"
    }
  },
  "worlds": {
    "title": "My Two Worlds",
    "finland": {
      "title": "Finland: Where I Trained",
      "points": [
        "World-class nursing education with evidence-based practice",
        "Rigorous clinical training in multiple healthcare settings",
        "Advanced certifications in geriatric and emergency care",
        "Technology-driven patient safety protocols"
      ]
    },
    "asia": {
      "title": "Southeast Asia: Where I Belong",
      "points": [
        "Deep understanding of Asian family dynamics in healthcare",
        "Fluent in Thai, English, and Finnish",
        "Cultural sensitivity in patient communication",
        "Experience bridging Eastern warmth with Western precision"
      ]
    },
    "bridge": {
      "title": "Bridging Both Worlds",
      "points": {
        "evidence": {
          "title": "Evidence-Based Care",
          "desc": "Finnish training meets Asian context"
        },
        "cultural": {
          "title": "Cultural Intelligence",
          "desc": "Understanding family-centered care"
        },
        "tech": {
          "title": "Tech-Savvy Approach",
          "desc": "Digital health literacy from Finland"
        },
        "family": {
          "title": "Family Partnership",
          "desc": "Respecting Asian healthcare values"
        }
      }
    }
  },
  "connect": {
    "modal": {
      "title": "Connect with Mona",
      "subtitle": "Choose how you'd like to connect. Booking a video call is the fastest way to discuss opportunities.",
      "close": "Close",
      "booking": {
        "title": "Book video interview",
        "subtitle": "Schedule a 30-min Google Meet call",
        "available": "Available slots this week",
        "cta": "Book now",
        "steps": {
          "calendar": {
            "title": "You'll be taken to Google Calendar",
            "desc": "A new tab will open with Mona's booking page"
          },
          "choose": {
            "title": "Choose a 30-minute slot",
            "desc": "Select a time that works best for you"
          },
          "meet": {
            "title": "You'll receive a Google Meet link",
            "desc": "Confirmation email with video call details"
          }
        }
      },
      "email": {
        "title": "Send email instead",
        "subtitle": "Quick introduction message",
        "cta": "Send email",
        "form": {
          "company": "Company name",
          "companyPlaceholder": "CityCare Hospital",
          "position": "Position title",
          "positionPlaceholder": "Registered Nurse (ICU)",
          "responsibilities": "Key responsibilities",
          "responsibilitiesPlaceholder": "Patient care, medication administration, team coordination",
          "name": "Your name",
          "namePlaceholder": "Jane Doe",
          "email": "Your email",
          "emailPlaceholder": "recruiter@citycare.sg",
          "phone": "Your phone (optional)",
          "phonePlaceholder": "+65 9123 4567"
        },
        "preview": {
          "title": "Email preview",
          "subject": "Subject:"
        },
        "actions": {
          "send": "Send email",
          "copy": "Copy draft",
          "copied": "Copied!"
        }
      },
      "whatsapp": {
        "title": "Chat on WhatsApp",
        "subtitle": "Direct message",
        "cta": "Open WhatsApp",
        "opening": "Opening WhatsApp...",
        "description": "A pre-filled message template will be ready for you to send",
        "popup": "If WhatsApp doesn't open automatically, please check your browser's pop-up settings"
      }
    }
  },
  "spotlight": {
    "tour": {
      "step1": {
        "title": "Let's connect on WhatsApp",
        "description": "Get instant responses to your questions about my experience and availability. The fastest way to start a conversation!",
        "action": "Message me"
      },
      "step2": {
        "title": "Download my full CV",
        "description": "Get detailed credentials, certifications, and work history in one comprehensive PDF. Perfect for formal review.",
        "action": "Download CV"
      },
      "step3": {
        "title": "Multiple ways to connect",
        "description": "Book a video call, send an email, or message me directly. Choose the option that works best for you!",
        "action": "Explore options"
      },
      "skip": "Skip",
      "progress": "Step {{current}} of {{total}}"
    },
    "widget": {
      "title": "Quick actions",
      "actions": {
        "whatsapp": "WhatsApp me",
        "downloadCv": "Download CV",
        "connect": "Connect options"
      },
      "tour": {
        "restart": "Restart tour",
        "settings": "Tour settings"
      },
      "settings": {
        "title": "Tour settings",
        "showForNewVisitors": "Show tour for new visitors",
        "showForNewVisitorsDesc": "Automatically guide first-time users",
        "note": "The tour will automatically show for new visitors and users who haven't visited in 7+ days. You can always restart it manually."
      }
    }
  },
  "cv": {
    "title": "CURRICULUM VITAE - SUDARAT BUNTHAWEE",
    "sections": {
      "personalInfo": "PERSONAL INFORMATION",
      "summary": "PROFESSIONAL SUMMARY",
      "licenses": "PROFESSIONAL LICENSES",
      "education": "EDUCATION",
      "experience": "PROFESSIONAL EXPERIENCE",
      "certifications": "CERTIFICATIONS & TRAINING",
      "skills": "SKILLS & COMPETENCIES",
      "languages": "LANGUAGES"
    },
    "personalInfo": {
      "fullName": "Full Name",
      "dateOfBirth": "Date of Birth",
      "nationality": "Nationality",
      "contact": "Contact",
      "email": "Email",
      "location": "Location"
    },
    "summary": "Dedicated Registered Nurse with Finnish healthcare training and active nursing licenses. Expertise in surgical, psychiatric, geriatric, and emergency care. Proven ability in evidence-based practice, patient safety, and multidisciplinary collaboration. Seeking to contribute clinical excellence and cultural adaptability to Singapore's healthcare system.",
    "licenses": {
      "nursing": {
        "title": "Finnish Nursing License",
        "details": "Licensed Registered Nurse (Sairaanhoitaja) | Registration Number: 10009985648 | Issued by: Valvira | Status: Active"
      },
      "medication": {
        "title": "Finnish Medication License",
        "details": "License Type: Love (Lääkkeenmääräämis Lupa hoitajille) | Status: Valid"
      }
    },
    "education": {
      "degree": "Bachelor of Health Care (Nursing Science)",
      "institution": "LAB University of Applied Sciences, Lahti, Finland",
      "year": "Year"
    },
    "experience": {
      "responsibilities": "Responsibilities",
      "achievements": "Key Achievements",
      "0": {
        "title": "Nursing Student - Acute Care Unit",
        "organization": "Päijät-Häme Central Hospital",
        "location": "Lahti, Finland",
        "period": "February 2025 - April 2025",
        "responsibilities": [
          "Provided comprehensive patient care in acute care settings, including vital signs monitoring, medication administration, and documentation in electronic health records (LifeCare)",
          "Performed clinical procedures such as IV cannulation, ECG recordings, and various patient care interventions",
          "Collaborated with multidisciplinary teams including physicians, physiotherapists, and pharmacists",
          "Assessed patient conditions, responded to changes in vital signs, and escalated concerns appropriately"
        ]
      },
      "1": {
        "title": "Nursing Student - Operating Theatre",
        "organization": "Etelä-Karjala Central Hospital",
        "location": "Lappeenranta, Finland",
        "period": "January 2025 - February 2025",
        "responsibilities": [
          "Gained comprehensive experience in perioperative nursing care across all three roles: anesthesia nurse, scrub nurse, and circulating nurse",
          "Assisted in surgical procedures while maintaining strict aseptic technique and sterile field protocols",
          "Monitored patients' vital signs and anesthesia responses using advanced monitoring equipment"
        ]
      },
      "2": {
        "title": "Registered Nurse - Surgical Ward",
        "organization": "Päijät-Häme Central Hospital, Ward R5",
        "location": "Lahti, Finland",
        "period": "December 2024 - February 2025",
        "responsibilities": [
          "Provided comprehensive pre-operative and post-operative nursing care for surgical patients in a 30-bed acute care ward",
          "Administered medications, IV therapy, and pain management according to physician orders and nursing protocols",
          "Monitored patient vital signs, wound healing, and post-surgical recovery"
        ],
        "achievements": [
          "Successfully managed care for high-acuity post-surgical patients requiring complex wound care",
          "Maintained 100% medication administration accuracy through careful verification and documentation"
        ]
      }
    },
    "certifications": {
      "0": {
        "category": "Psychiatric & Mental Health",
        "items": [
          "Anxious and Sleepless Youth: Adolescent Psychiatric Perspectives (55 min) - Nov 2024",
          "Motivational Interviewing (60 min) - Dec 2022"
        ]
      },
      "1": {
        "category": "Geriatric & Elderly Care",
        "items": [
          "Gerasthenia Identification (30 min) - Oct 2024",
          "Elderly Medication Management (60 min) - Sept 2024",
          "Polypharmacy in the Elderly (40 min) - Sept 2024",
          "Fall Prevention (60 min) - Sept 2024"
        ]
      },
      "2": {
        "category": "Acute & Emergency Care",
        "items": [
          "Neurological Patient Emergency Assessment (60 min) - Nov 2023",
          "Systematic Assessment of Vital Functions Using ABCDE Principles (30 min) - Oct 2023",
          "Central Venous Catheter (CVK) Insertion and Use (70 min) - Nov 2023"
        ]
      }
    },
    "skills": {
      "clinical": {
        "title": "Clinical Skills",
        "items": [
          "Comprehensive patient assessment and vital signs monitoring",
          "Advanced wound care and dressing changes",
          "Medication administration (oral, IV, IM, SC)",
          "IV cannulation, catheterization, and NG tube management",
          "Pain assessment and management",
          "Pre-operative and post-operative patient care"
        ]
      },
      "technical": {
        "title": "Technical Skills",
        "items": [
          "LifeCare Electronic Health Record (EHR) system",
          "Medical equipment operation (vital signs monitors, infusion pumps, oxygen delivery systems)",
          "Infection control protocols and sterile techniques",
          "Emergency response protocols and basic life support"
        ]
      },
      "soft": {
        "title": "Interpersonal Skills",
        "items": [
          "Excellent communication and active listening skills",
          "Strong empathy and patient-centered care",
          "Effective team collaboration in multidisciplinary settings",
          "Time management in high-pressure environments",
          "Cultural sensitivity with diverse patient populations"
        ]
      }
    },
    "languages": {
      "thai": "Thai",
      "finnish": "Finnish",
      "english": "English"
    },
    "languageProficiency": {
      "native": "Native",
      "fluent": "Fluent",
      "professional_b2": "Professional (B2)"
    },
    "generated": "Generated"
  },
  "aria": {
    "languageSelector": "Language selector",
    "closeModal": "Close modal",
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "skipToContent": "Skip to main content",
    "loading": "Loading",
    "error": "Error"
  }
}
